import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { MatSliderDragEvent } from '@angular/material/slider';
import { IPlayable, VgApiService } from '@videogular/ngx-videogular/core';
import { ITranscriptSentence } from '../../../models/project/take/transcript-model';

@Component({
    selector: 'app-scrub-bar',
    templateUrl: './scrub-bar.component.html',
    styleUrls: ['./scrub-bar.component.scss'],
})
export class ScrubBarComponent implements OnInit {
    @Input({ alias: 'currentTimeInSeconds', required: true })
    set currentTimeForVideoFromInput(newTime: number) {
        this.currentTimeFromVideo = newTime;
    }
    @Output()
    newSeekInMillisEmitter = new EventEmitter<number>();
    @Output()
    dragStartedEmitter = new EventEmitter<void>();
    @Output()
    dragEndedEmitter = new EventEmitter<void>();

    @Input()
    duration: number;

    @Input({ alias: 'fake-duration' })
    fakeDuration: number;

    // Sent only from edit room
    @Input()
    currentTime: number;

    @Input()
    navigateFromEditRoom: boolean;

    currentTimeFromVideo: number = 0;
    vgApiMedia: IPlayable;
    @Input()
    trimStart: number = 0;
    @Input()
    trimEnd: number = 0;
    constructor() {}

    ngOnInit(): void {}

    onDragging(timeInMilliseconds: number) {
        this.newSeekInMillisEmitter.emit(timeInMilliseconds + this.trimStart);
    }

    dragStarted(event: MatSliderDragEvent) {
        this.dragStartedEmitter.emit();
    }

    dragEnded(event: MatSliderDragEvent) {
        this.dragEndedEmitter.emit();
    }

    onCurrentPositionChange(newPosition: number): void {
        // Do something with the new position
        console.log('Current Position changed:', newPosition);
    }
}
